<template>
    <div class="form-group">
        <geo-autocomplete
            v-model="value"
            :config="config"
            :config_map="config_map"
            :contract="contract"
            :districts="districts"
            :filters="filters"
            :placeholder="placeholder"
            :city="city"
            :searchData="searchData"
            :section="section"
            :sector="sector"
            @input="$emit('input', value)"
            @show-districts="showDistricts"
            @hide-districts="hideDistricts"
        />

        <keep-alive>
            <districts-list
                v-if="show_districts"
                v-model="form.districts"
                :config="config"
                :config_map="config_map"
                :city="city"
                :searchData="searchData"
                :contract="contract"
                :districts="districts"
                :sector="sector"
                :section="section"
                @hide-districts="hideDistricts"
            />
        </keep-alive>
    </div>
</template>

<script>
import GeoAutocomplete from '../../GeoAutocomplete'
import DistrictsList from '../../DistrictsList'

export default {
    components: {
        'geo-autocomplete': GeoAutocomplete,
        'districts-list': DistrictsList,
    },

    props: {
        config: {
            type: Object,
            required: true,
        },

        config_map: {
            type: Object,
            required: true,
        },

        contract: {
            type: String,
            required: true,
        },

        districts: {
            type: Array,
            required: false,
        },

        filters: {
            type: Object,
            required: true,
        },

        geo_data: {
            type: Object,
            required: true,
        },

        polygon_id: {
            type: String,
            required: false,
        },

        placeholder: {
            type: String,
            required: false,
        },

        searchData: {
            type: Object,
            required: true,
        },

        section: {
            type: String,
            required: true,
        },

        sector: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            value: null,
            city: null,
            form: {
                contract: 'acquis',
                districts: '',
                sector: this.sector,
            },
            show_districts: false,
        }
    },

    mounted() {
        if(this.searchData.city) {
            this.city = this.geo_data
        }
    },

    watch: {
        searchData(value) {
            console.log('cambiato searchData di autocomplete', value)
            if(value.city) {
                this.city = value
            }
        },
    },

    methods: {
        showDistricts(city) {
            if(city) {
                this.city = city
            }

            this.show_districts = true
        },

        hideDistricts() {
            this.show_districts = false
        }
    }
}
</script>
